import Component, { Topic } from 'component';

customElements.define('x-inline-carousel', class extends Component {
    constructor() {
        super();
        this.$element.track = this.querySelector('[data-inline-carousel-element="track"]');
        this.$element.navPrev = this.querySelector('[data-inline-carousel-element="nav-prev"]');
        this.$element.navNext = this.querySelector('[data-inline-carousel-element="nav-next"]');
        this.$element.view = this.querySelector('[data-inline-carousel-element="view"]');
    }

    currentItem = 0;
    itemsCount = 0;
    columns = 1;
    endOffset;
    items = [];
    scrollTimeout;

    render() {
        this.watchViewport = true;
        this.itemsCount = Number(this.getAttribute('items-count'));
        this.columns = Number(this.getAttribute('columns'));
    }

    onMobile() {
        this.initItems();

        this.on(this.$element.view, 'scroll', () => {
            clearTimeout(this.scrollTimeout);

            this.scrollTimeout = setTimeout(() => {
                this.updatePaginationByScroll();
            }, 80);
        });

        if ('onscrollsnapchange' in window) {
            this.on(this.$element.view, 'scrollsnapchange', this.handleSnapChange);
        } else {
            this.classList.add('inline-carousel--nosnap');
        }

        this.sub(Topic.CAROUSEL_PAGINATION_UPDATE, index => {
            const target = this.items[index];

            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: this.columns < 2 ? 'nearest' : 'start'
                });

                this.pub(Topic.CAROUSEL_PAGINATION_SET, index);
            }
        });
    }

    initItems() {
        this.items = [];

        this.$element.track?.childNodes.forEach(node => {
            if (node instanceof Element && (node.tagName !== 'LINK' && node.tagName !== 'SCRIPT')) {
                this.items.push(node);
            }
        });
    }

    handleSnapChange(e) {
        const target = e.snapTargetInline;
        const index = this.items.indexOf(target);

        if (index >= 0) {
            this.pub(Topic.CAROUSEL_PAGINATION_SET, index);
        }
    }

    updatePaginationByScroll() {
        if (!this.$element.view || !this.items.length) {
            return;
        }

        const viewRect = this.$element.view.getBoundingClientRect();
        const viewCenter = viewRect.left + viewRect.width / 2;

        let closestIndex = 0;
        let closestDistance = Infinity;

        this.items.forEach((item, index) => {
            const itemRect = item.getBoundingClientRect();
            const itemCenter = itemRect.left + itemRect.width / 2;
            const distance = Math.abs(viewCenter - itemCenter);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        this.pub(Topic.CAROUSEL_PAGINATION_SET, closestIndex);
    }

    onDesktop() {
        this.endOffset = this.itemsCount - this.columns;
        this.checkOffsets();

        this.on(this.$element.navPrev, 'click', () => {
            this.updatePosition(-1);
        });

        this.on(this.$element.navNext, 'click', () => {
            this.updatePosition(1);
        });
    }

    checkOffsets() {
        this.classList.toggle('inline-carousel--disable-prev', this.currentItem <= 0);
        this.classList.toggle('inline-carousel--disable-next', this.currentItem >= this.endOffset);
    }

    updatePosition(direction) {
        this.currentItem += direction;
        this.checkOffsets();
        this.style.setProperty('--inline-carousel-current-index', this.currentItem.toString());
    }
});